module.exports = __webpack_public_path__ + "img/banner-forth.f5ab292b.png";